import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  EventAvailabilityDetails,
  PremiumCodeDetails,
  PremiumInventoryDetails,
  ReservationFlowState,
  SubscriptionDetails,
  TicketDetails,
} from "features/types";

const initialState: ReservationFlowState = {
  selectedSubscription: null,
  selectedEvent: null,
  selectedPartySize: 0,
  originalHeldDetail: {
    section: null,
    row: null,
  },
  actualHeldDetail: [],
  premiumInventory: null,
  selectedPremiumCode: null,
  // change seats flow
  isChangingSeats: false,
  originalEventId: undefined,
  originalTickets: [],
  keptOriginalTicketIds: [],
  eventFilters: {
    eventTypes: [],
    months: [],
    days: [],
  },
};

const reservationFlowSlice = createSlice({
  name: "reservationFlow",
  initialState,
  reducers: {
    setSelectedSubscription: (
      state,
      action: PayloadAction<SubscriptionDetails>
    ) => {
      state.selectedSubscription = action.payload;
    },
    setSelectedEvent: (
      state,
      action: PayloadAction<EventAvailabilityDetails>
    ) => {
      state.selectedEvent = action.payload;
    },
    setSelectedPartySize: (state, action: PayloadAction<number>) => {
      state.selectedPartySize = action.payload;
    },
    setPremiumInventory: (
      state,
      action: PayloadAction<PremiumInventoryDetails | null>
    ) => {
      state.premiumInventory = action.payload;
    },
    setSelectedPremiumCode: (
      state,
      action: PayloadAction<PremiumCodeDetails | null>
    ) => {
      state.selectedPremiumCode = action.payload;
    },
    setOriginalHeldDetail: (
      state,
      action: PayloadAction<{ section: string; row: string }>
    ) => {
      state.originalHeldDetail = action.payload;
    },
    setActualHeldDetail: (state, action: PayloadAction<TicketDetails[]>) => {
      state.actualHeldDetail = action.payload;
    },
    setIsChangingSeat: (state, action: PayloadAction<boolean>) => {
      state.isChangingSeats = action.payload;
    },
    setOriginalEventId: (state, action: PayloadAction<number | undefined>) => {
      state.originalEventId = action.payload;
    },
    setOriginalTickets: (state, action: PayloadAction<TicketDetails[]>) => {
      state.originalTickets = action.payload;
    },
    setKeptOriginalTicketIds: (state, action: PayloadAction<number[]>) => {
      state.keptOriginalTicketIds = action.payload;
    },
    setEventFilters: (
      state,
      action: PayloadAction<ReservationFlowState["eventFilters"]>
    ) => {
      state.eventFilters = action.payload;
    },
    resetReservationFlow: () => initialState,
    resetPremiumInventory: (state) => {
      state.premiumInventory = null;
      state.selectedPremiumCode = null;
    },
  },
});

export const {
  setSelectedEvent,
  setSelectedSubscription,
  resetReservationFlow,
  setSelectedPartySize,
  setOriginalHeldDetail,
  setActualHeldDetail,
  setSelectedPremiumCode,
  setIsChangingSeat,
  setOriginalEventId,
  setOriginalTickets,
  setKeptOriginalTicketIds,
  setEventFilters,
  setPremiumInventory,
  resetPremiumInventory,
} = reservationFlowSlice.actions;
export default reservationFlowSlice.reducer;
